import { Outlet } from 'react-router-dom';
import TabelaPerfilMembro from './components/tabela';

export default function PerfilMembro() {


  return (
    <>
      <Outlet/>
      <TabelaPerfilMembro />
    </>
  )
}
